import { render, staticRenderFns } from "./settings-organization.vue?vue&type=template&id=179b709e&scoped=true&"
import script from "./settings-organization.vue?vue&type=script&lang=js&"
export * from "./settings-organization.vue?vue&type=script&lang=js&"
import style0 from "./settings-organization.vue?vue&type=style&index=0&id=179b709e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179b709e",
  null
  
)

export default component.exports